import React from 'react';
import Link from 'gatsby-link';
import { withRouter } from 'react-router';
import { Scrollbars } from 'react-custom-scrollbars';
import { Helmet } from 'react-helmet';

class CommunityRulesPage extends React.Component {
  render () {
    return (
      <div id="community-rules" className={`page community-rules`}>
        <Helmet>
          <title>Community Rules</title>
          <meta name="description" content={'ParkYou! unites micro-communities of city car owners to instantaneously find street parking. We are launching in Fall 2018. Read our community rules here.'} />
        </Helmet>

        <Scrollbars className="article">
          <h1>Community Rules</h1>
          <p style={{ marginTop: "10px" }}>The ParkYou! community rules are below. Parky says if we all follow them everyone will have an awesome parking experience.</p>

          <h2>Find a Spot Rules</h2>
          <ol>
            <li>You may cancel a search at any time before accepting a spot. Once you have accepted a spot, however, you must take it, even if you see an empty spot beforehand.</li>
            <li>Make sure you press the “Accept” button within the 25 second time limit when a spot is offered to you.</li>
            <li>Do not rush to get to your spot. And slow down as you get close. Stay safe and look out for your parking partner.</li>
            <li>The “Arrived” button will become pressable shortly before you actually arrive. Do not press it until you are within 75 feet of the parking spot.</li>
            <li>When you arrive, pull up to your benefactor and smile and wave. They’re a great neighbor. Once they see you, back up so they can pull out.</li>
          </ol>

          <h2>Offer a Spot Rules</h2>
          <ol>
            <li>Only offer your spot once you have arrived at your vehicle.</li>
            <li>Only offer free spots in primarily residential areas when there is no alternate side parking requirement until at least the next day.</li>
            <li>Never offer a free spot in primarily commercial areas unless the spot is available for at least two hours.</li>
            <li>You may cancel your offer at any time before your offered spot is accepted, but once it is accepted, you must wait for your parking partner to arrive.</li>
            <li>Don’t turn your lights or blinker on until you receive a notification that your parking partner is close.</li>
          </ol>

          <h2>Guidelines for Interacting with Non-ParkYou! Members While Waiting</h2>
          <p>If, while waiting for someone to select your spot or for your parking partner to arrive, another driver asks you for the spot, tell them “I’m not leaving.” Most people will drive away. If they are insistent, explain to them that a neighbor is coming to take the spot in a few minutes. If they have further questions, it may be an excellent opportunity to invite them to join the ParkYou! Community. Please use your judgment.</p>
        </Scrollbars>
      </div>
    )
  }
}

export default withRouter(CommunityRulesPage);
 


// WEBPACK FOOTER //
// ./src/pages/community-rules.js